import PropTypes from 'prop-types'
import './memoryItem.scss'

const MemoryItem = ({ type, title, description, date }) => {
  const getTypeIcon = (type) => {
    switch (type) {
      case 'Logro':
        return '★'
      case 'Evento':
        return '◉'
      case 'Actividad':
        return '◎'
      default:
        return '◆'
    }
  }

  return (
    <div className={`memory-item memory-item--${type.toLowerCase()}`}>
      <div className='memory-item__badge'>
        <span 
          className={`memory-item__icon memory-item__icon--${type.toLowerCase()}`}
          aria-label={`Tipo: ${type}`}
        >
          {getTypeIcon(type)}
        </span>
        <span className='memory-item__type'>{type}</span>
      </div>
      
      <div className='memory-item__content'>
        <time className='memory-item__date'>{date}</time>
        <h3 className='memory-item__title'>{title}</h3>
        <p className='memory-item__description'>{description}</p>
      </div>
    </div>
  )
}

MemoryItem.propTypes = {
  type: PropTypes.oneOf(['Actividad', 'Evento', 'Logro']).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired
}

export default MemoryItem
